import bootstrap from 'bootstrap'
import CustomSelect from "./../resources-js/custom-select";

window.$ = $

const body = $('body');

let windowWidth = window.innerWidth

const addCustomBackdrop = () => {
    body.append('<div class="navbar-backdrop custom-backdrop">');
    body.addClass('overflow-hidden')
    $('.navbar-backdrop').fadeIn(120);
}
const removeCustomBackdrop = () => {
    body.removeClass('overflow-hidden')
    $('.navbar-backdrop').fadeOut(120);
    setTimeout(function () {
        $('.custom-backdrop').remove();
    }, 120)
}

const app = function ($) {

    const customInputCheckbox = () => {
        $('.form-box-check').on('click', function (){
            $(this).find('input').prop('checked', true)
            $('.form-box-check').removeClass('checked')
            $(this).addClass('checked')
        })
    }
    const navbarCollapse = () => {
        const navbarBtnHandle = $('.navbar-collapse');

        function closeNavbarMenu() {
            body.removeClass('menu-open');
            removeCustomBackdrop()
        }

        navbarBtnHandle.on('shown.bs.collapse', function () {
            $('.nav-menu').append('<div class="navbar-backdrop custom-backdrop">');
            body.addClass('menu-open')
            setTimeout(function () {
                $('.header-top').removeClass('shift')
            }, 120)

            $('.navbar-backdrop').fadeIn(120);
        });
        navbarBtnHandle.on('hidden.bs.collapse', function () {
            closeNavbarMenu();
        });

        body.click(function (event) {
            event.stopPropagation()
            if ($(event.target).closest('.custom-backdrop').length)
                navbarBtnHandle.collapse('hide');
            return
        });
    };
    const validationBootstrap = () => {
        (() => {
            'use strict'

            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            const forms = document.querySelectorAll('.needs-validation')

            // Loop over them and prevent submission
            Array.from(forms).forEach(form => {
                form.addEventListener('submit', event => {
                    if (!form.checkValidity()) {
                        event.preventDefault()
                        event.stopPropagation()
                    }
                    form.classList.add('was-validated')
                }, false)
            })
        })()
    }


    return {
        init() {
            customInputCheckbox()
            navbarCollapse()
            validationBootstrap()
        }
    }
};

jQuery(document).ready(function ($) {
    app($).init();
});

CustomSelect();
